import { useContext } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../store/auth-context';

const Navbar = () => {
  const hover = 'navbar__lists-item';
  const context = useContext(AuthContext);

  useEffect(() => {}, [context.pathname]);

  return (
    <div className='navbar uppercase '>
      <div className='navbar__border-top'></div>
      <div className='navbar__border-bottom'></div>
      <h1 className='navbar__header'>Select an option</h1>
      <ul className='navbar__lists me-5'>
        <Link to='/'>
          <li
            className={context.pathname === '/' ? `${hover} selected` : hover}
          >
            Intro
          </li>
        </Link>

        <Link to='/about'>
          <li
            className={
              context.pathname === '/about' ? `${hover} selected` : hover
            }
          >
            About me
          </li>
        </Link>

        <Link to='/projects'>
          <li
            className={
              context.pathname === '/projects' ? `${hover} selected` : hover
            }
          >
            Projects
          </li>
        </Link>

        <Link to='/experience'>
          <li
            className={
              context.pathname === '/experience' ? `${hover} selected` : hover
            }
          >
            Experience
          </li>
        </Link>

        {/* <li
          className={activeTab === 'ui/ux' ? `${hover} selected` : hover}
          onClick={() => handleActiveTab('ui/ux')}
        >
          UI/UX
        </li> */}

        <a
          className={hover}
          href='https://drive.google.com/file/d/1EFV0y3xiIgK9RrWQqMCna1RvY9QLTcQI/view'
          target='_blank'
          rel='noreferrer'
        >
          Download CV
        </a>

        <Link to='/contact'>
          <li
            className={
              context.pathname === '/contact' ? `${hover} selected` : hover
            }
          >
            Contact
          </li>
        </Link>
      </ul>
    </div>
  );
};

export default Navbar;
